import Helper from "@ember/component/helper"
import _ from "lodash"

export function min(params) {
  let array = params[0]
  return _.min(array)
}

export default class Min extends Helper {
  compute = min
}
